import { Helmet } from 'react-helmet-async';
import { CANONICAL_BASE_URL } from '../config/site';

const SEO = ({
  title,
  description,
  canonical,
  keywords,
  ogType = 'website',
  ogImage,
  schema,
}) => {
  // Canonical URLs ALWAYS resolve to the apex domain regardless of which
  // host (www / preview / .com) the visitor or crawler hits.
  const baseUrl = CANONICAL_BASE_URL;
  const fullCanonical = canonical ? `${baseUrl}${canonical}` : baseUrl;
  const defaultOgImage = `${baseUrl}/og-image.jpg`;
  const finalOgImage = ogImage || defaultOgImage;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullCanonical} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={finalOgImage} />
      <meta property="og:locale" content="en_GB" />
      <meta property="og:site_name" content="Brightson Accounting Limited" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullCanonical} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={finalOgImage} />

      {/* Schema.org JSON-LD */}
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
